module.exports = __webpack_public_path__ + "img/anasayfa-urun-buyuk.88b991a1.png";